// FILE_ID: MAIN_POPUP_JS
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.duofits-size-popup');
  const mainContainer = document.querySelector('.duofits-popup__container');
  if (!container || !mainContainer) return;
  if (container.parentNode !== document.body) document.body.appendChild(container);

  // --- GALLERY LOGIC (Unchanged) ---
  const galleryBtn = container.querySelector('#trigger-gallery-popup');
  const galleryOverlay = container.querySelector('#overlay-gallery');
  const galleryCloseBtn = galleryOverlay ? galleryOverlay.querySelector('[data-close-gallery]') : null;
  const carousel = galleryOverlay ? galleryOverlay.querySelector('.duofits-carousel') : null;
  const dotsContainer = galleryOverlay ? galleryOverlay.querySelector('.duofits-carousel-dots') : null;
  let originRect = {};

  if(galleryBtn && galleryOverlay) {
    galleryBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const containerRect = mainContainer.getBoundingClientRect();
      const btnRect = galleryBtn.getBoundingClientRect();
      const relTop = btnRect.top - containerRect.top;
      const relLeft = btnRect.left - containerRect.left;
      originRect = { top: relTop, left: relLeft, width: btnRect.width, height: btnRect.height };
      galleryOverlay.style.top = `${relTop}px`;
      galleryOverlay.style.left = `${relLeft}px`;
      galleryOverlay.style.width = `${btnRect.width}px`;
      galleryOverlay.style.height = `${btnRect.height}px`;
      galleryOverlay.style.borderRadius = '14px'; 
      galleryOverlay.style.opacity = '1';
      galleryOverlay.style.pointerEvents = 'auto';
      galleryBtn.classList.add('is-hidden');
      galleryOverlay.offsetHeight; 
      galleryOverlay.classList.add('is-active');
      mainContainer.classList.add('has-active-gallery');
      requestAnimationFrame(() => {
         const contWidth = containerRect.width;
         const contHeight = containerRect.height;
         let targetW = contWidth * 0.92;
         let targetH = Math.min(contHeight * 0.65, targetW * 1.25);
         let targetTop = (contHeight - targetH) / 2;
         let targetLeft = (contWidth - targetW) / 2;
         galleryOverlay.style.top = `${targetTop}px`;
         galleryOverlay.style.left = `${targetLeft}px`;
         galleryOverlay.style.width = `${targetW}px`;
         galleryOverlay.style.height = `${targetH}px`;
         galleryOverlay.style.borderRadius = '16px'; 
      });
    });
    const closeGallery = () => {
      galleryOverlay.classList.remove('is-active');
      mainContainer.classList.remove('has-active-gallery');
      galleryOverlay.style.top = `${originRect.top}px`;
      galleryOverlay.style.left = `${originRect.left}px`;
      galleryOverlay.style.width = `${originRect.width}px`;
      galleryOverlay.style.height = `${originRect.height}px`;
      galleryOverlay.style.borderRadius = '14px';
      setTimeout(() => {
        galleryOverlay.style.opacity = '0';
        galleryOverlay.style.pointerEvents = 'none';
        galleryBtn.classList.remove('is-hidden');
      }, 400); 
    };
    if(galleryCloseBtn) galleryCloseBtn.addEventListener('click', (e) => { e.stopPropagation(); closeGallery(); });
    if(carousel && dotsContainer) {
       carousel.addEventListener('scroll', () => {
         const scrollLeft = carousel.scrollLeft;
         const itemWidth = carousel.clientWidth;
         const index = Math.round(scrollLeft / itemWidth);
         const dots = dotsContainer.querySelectorAll('.duofits-dot');
         dots.forEach((dot, i) => {
             if(i === index) dot.classList.add('is-active');
             else dot.classList.remove('is-active');
          });
       });
    }
  }

  // --- FIT GUIDE LOGIC ONLY (No Fabric Here) ---
  const fitBtn = container.querySelector('#trigger-fit-popup');
  const fitOverlay = container.querySelector('#overlay-fit');
  if(fitBtn) {
    fitBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if(fitOverlay) fitOverlay.classList.add('is-active');
    });
  }

  // CLOSE LOGIC
  const closeOverlayBtns = container.querySelectorAll('[data-close-overlay]');
  closeOverlayBtns.forEach(btn => btn.addEventListener('click', (e) => {
    e.stopPropagation();
    if(fitOverlay) fitOverlay.classList.remove('is-active');
    // Note: Fabric closes via its own internal JS now
  }));

  // --- SIZING LOGIC (Dynamic Grid Layout) ---
  const toastEl = container.querySelector('#duofits-toast');
  let toastTimer;
  function showToast(msg) {
    if (!toastEl) return;
    toastEl.querySelector('span').textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toastEl.classList.remove('is-visible'); }, 2500);
  }

  const lockedFits = container.querySelectorAll('[data-locked-fit]');
  lockedFits.forEach(item => {
    item.addEventListener('click', (e) => { e.stopPropagation(); showToast("This fit is not available for this product"); });
  });

  let variants = [], masterData = [];
  try {
    const varData = document.getElementById('duofits-combo-variants');
    const expData = document.getElementById('duofits-explicit-data');
    if(varData) variants = JSON.parse(varData.textContent);
    if(expData) masterData = JSON.parse(expData.textContent).filter(x => x); 
  } catch (e) { }

  if (masterData.length > 0) {
      const clean = (str) => str ? str.toString().trim().toUpperCase() : '';
      const formatName = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      const selections = masterData.map(data => ({ realIndex: data.realIndex, name: data.tabName, selectedValue: null }));
      let currentTabIdx = 0;
      let currentUnit = 'in'; // Default to inches

      const domTabs = container.querySelector('.duofits-tabs');
      const domGrid = container.querySelector('.duofits-sizes-grid');
      // UPDATED SELECTOR: Use the inner container so we don't wipe the toggle
      const domDataList = container.querySelector('#duofits-table-rows');
      const domSummaryLine = container.querySelector('.duofits-summary-line');
      
      const unitBtns = container.querySelectorAll('.duofits-unit-btn');

      const ui = {
        progressText: container.querySelector('.duofits-progress-text'),
        progressFill: container.querySelector('.duofits-progress-fill'),
        btnNext: container.querySelector('[data-action="next"]'),
        btnPrev: container.querySelector('[data-action="prev"]'),
        btnBuy: container.querySelector('.duofits-buy-btn')
      };

      unitBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const unit = btn.getAttribute('data-unit');
          if (unit && unit !== currentUnit) {
            currentUnit = unit;
            unitBtns.forEach(b => b.classList.remove('is-active'));
            btn.classList.add('is-active');
            updateUI();
          }
        });
      });

      function buildStaticUI() {
        domTabs.innerHTML = '';
        masterData.forEach((data, i) => {
          const btn = document.createElement('button');
          btn.textContent = data.tabName;
          btn.addEventListener('click', () => { currentTabIdx = i; updateUI(); });
          domTabs.appendChild(btn);
        });
      }

      function isOptionAvailable(val) {
        const tempSelections = selections.map(s => s.selectedValue);
        tempSelections[currentTabIdx] = val;
        const matchingVariants = variants.filter(v => {
          return tempSelections.every((selVal, idx) => {
            if (selVal === null) return true; 
            return clean(v.options[masterData[idx].realIndex]) === clean(selVal);
          });
        });
        return matchingVariants.some(v => v.available);
      }

      function updateUI() {
        const currentData = masterData[currentTabIdx];
        const currentSel = selections[currentTabIdx];
        // Dynamic columns from Liquid
        const columns = currentData.columns || ['Chest', 'Length', 'Sleeve'];

        const convert = (val) => {
          if (!val) return '-';
          if (currentUnit === 'in') return val;
          const num = parseFloat(val);
          return isNaN(num) ? val : (num * 2.54).toFixed(1);
        };

        Array.from(domTabs.children).forEach((btn, i) => {
          if (i === currentTabIdx) btn.classList.add('is-active');
          else btn.classList.remove('is-active');
        });

        // 1. Grid
        domGrid.innerHTML = ''; 
        currentData.values.forEach(val => {
          const pill = document.createElement('div');
          pill.className = 'duofits-size-pill';
          pill.textContent = val;
          if (clean(val) === clean(currentSel.selectedValue)) pill.classList.add('is-selected');
          const available = isOptionAvailable(val);
          if (!available) {
            pill.classList.add('is-unavailable');
            pill.addEventListener('click', () => showToast(`Size ${val} is not available`));
          } else {
            pill.addEventListener('click', () => { currentSel.selectedValue = val; updateUI(); });
          }
          domGrid.appendChild(pill);
        });

        // 2. Data List (Table Grid Style)
        domDataList.innerHTML = '';
        if (currentData.chartData && currentData.chartData.length > 0) {
          
          // Construct CSS Grid Template: 45px for Size, rest 1fr
          const colCount = columns.length;
          const gridStyle = `display: grid; grid-template-columns: 45px repeat(${colCount}, 1fr); gap: 10px; align-items: center;`;

          // Inject Header Row
          const headerRow = document.createElement('div');
          headerRow.className = 'duofits-size-data-row';
          headerRow.style.cssText = gridStyle + " cursor: default; background: transparent; box-shadow: none; margin-bottom: 0px;";
          
          let headerHTML = `<div style="font-weight: 800; text-align: left; font-size: 11px; color: #000;">Size</div>`;
          columns.forEach(colName => {
              headerHTML += `<div style="font-weight: 800; text-align: right; font-size: 11px; color: #000;">${colName}</div>`;
          });
          headerRow.innerHTML = headerHTML;
          domDataList.appendChild(headerRow);

          // Render Data Rows
          currentData.chartData.forEach(entry => {
            const row = document.createElement('div');
            row.className = 'duofits-size-data-row';
            row.style.cssText = gridStyle; // Apply same grid layout
            
            // Safe Size Lookup (handle different casing)
            const sizeKey = Object.keys(entry).find(k => k.toLowerCase() === 'size' || k.toLowerCase() === 'size_name');
            const sizeVal = sizeKey ? entry[sizeKey] : '?';

            if (currentSel.selectedValue && clean(sizeVal) === clean(currentSel.selectedValue)) {
              row.classList.add('is-highlighted');
              setTimeout(() => { row.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 50);
            }
            
            let rowHTML = `<div style="text-align: left; font-weight: 700; color: #333;">${sizeVal}</div>`;
            
            // Dynamic Value Extraction Loop
            columns.forEach(col => {
                // Find key in entry that case-insensitively matches column name
                const key = Object.keys(entry).find(k => k.toLowerCase() === col.toLowerCase().trim());
                const rawVal = key ? entry[key] : '-';
                const finalVal = convert(rawVal);
                rowHTML += `<div style="text-align: right; color: #555;">${finalVal}</div>`;
            });

            row.innerHTML = rowHTML;
            
            const available = isOptionAvailable(sizeVal);
            if (!available) {
               row.style.opacity = '0.5';
               row.addEventListener('click', () => showToast(`Size ${sizeVal} is unavailable`));
            } else {
               row.addEventListener('click', () => {
                 const matchedValue = currentData.values.find(v => clean(v) === clean(sizeVal));
                 if (matchedValue) { currentSel.selectedValue = matchedValue; updateUI(); }
               });
            }
            domDataList.appendChild(row);
          });
        } else { domDataList.innerHTML = '<div style="text-align:center;color:#999;font-size:11px;">Size chart not available</div>'; }
        
        // 3. Footer Summary
        domSummaryLine.innerHTML = '';
        selections.forEach((sel, i) => {
          const item = document.createElement('span');
          item.className = 'duofits-summary-item';
          if (i === currentTabIdx) item.classList.add('is-active-step');
          item.innerHTML = `${formatName(sel.name)}: <b>${sel.selectedValue || '—'}</b>`;
          item.addEventListener('click', () => { currentTabIdx = i; updateUI(); });
          domSummaryLine.appendChild(item);
          if (i < selections.length - 1) {
            const div = document.createElement('span');
            div.className = 'duofits-divider';
            div.textContent = '|';
            domSummaryLine.appendChild(div);
          }
        });
        const filledCount = selections.filter(s => s.selectedValue).length;
        const totalCount = selections.length;
        const percentage = (filledCount / totalCount) * 100;
        ui.progressText.textContent = `${filledCount} OF ${totalCount} SELECTED`;
        ui.progressFill.style.width = `${percentage}%`;
        if (filledCount === totalCount) ui.progressFill.classList.add('is-complete');
        else ui.progressFill.classList.remove('is-complete');
        ui.btnPrev.disabled = (currentTabIdx === 0);
        ui.btnNext.disabled = (currentTabIdx === selections.length - 1);
        const variantId = findVariant();
        if (ui.btnBuy) {
          if (variantId) {
            ui.btnBuy.classList.add('is-unlocked');
            const mainInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
            if (mainInput) mainInput.value = variantId;
          } else {
            ui.btnBuy.classList.remove('is-unlocked');
          }
        }
      }
      function findVariant() {
        if (selections.some(s => s.selectedValue === null)) return null;
        const v = variants.find(v => {
          return selections.every(sel => clean(v.options[sel.realIndex]) === clean(sel.selectedValue));
        });
        return (v && v.available) ? v.id : null;
      }
      if(ui.btnNext) ui.btnNext.addEventListener('click', () => { if (currentTabIdx < selections.length - 1) { currentTabIdx++; updateUI(); } });
      if(ui.btnPrev) ui.btnPrev.addEventListener('click', () => { if (currentTabIdx > 0) { currentTabIdx--; updateUI(); } });
      if(ui.btnBuy) ui.btnBuy.addEventListener('click', (e) => {
        e.preventDefault();
        const vId = findVariant();
        if (vId) {
          const formData = new FormData();
          formData.append('id', vId);
          formData.append('quantity', 1);
          fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData })
            .then(r => r.json())
            .then(() => {
              // 🔥 Trigger the SAME checkout button that Razorpay Magic Checkout hooks into
              const checkoutBtn =
                document.querySelector('#checkout') ||
                document.querySelector('button[name="checkout"]') ||
                document.querySelector('form[action="/cart"] button[name="checkout"]');
          
              if (checkoutBtn) {
                checkoutBtn.click();
                return;
              }
          
              // fallback: if checkout button isn't in DOM (quickview etc.), open cart
              window.location.href = '/cart';
            })
            .catch(console.error);
        }
      });
      buildStaticUI();
      if(masterData.length > 0) updateUI();
  }

  // --- FIT TABS ---
  const fitTabBtns = container.querySelectorAll('.duofits-fit-visual-item[data-fit-handle]');
  if(fitTabBtns.length > 0) {
     const labelText = container.querySelector('#fit-label-text');
     fitTabBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
           if(btn.hasAttribute('data-locked-fit') || btn.classList.contains('is-locked')) { e.stopPropagation(); return; }
           e.stopPropagation();
           fitTabBtns.forEach(b => b.classList.remove('is-active'));
           btn.classList.add('is-active');
           const newName = btn.getAttribute('data-fit-name');
           if(labelText && newName) labelText.textContent = newName;
        });
     });
  }
});


// ================================
// DUOFITS EXTRA ANIMATIONS + LOCK HINT
// Paste at the END of duofits-size-popup.js
// ================================
document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector(".duofits-size-popup");
  if (!popup) return;

  const buyBtn = popup.querySelector(".duofits-buy-btn");
  if (!buyBtn) return;

  // Create hint toast (locked click message)
  let hint = popup.querySelector(".duofits-lock-hint");
  if (!hint) {
    hint = document.createElement("div");
    hint.className = "duofits-lock-hint";
    hint.textContent = "Pehle size select karo, tab unlock hoga 🙂";
    popup.querySelector(".duofits-popup__container")?.appendChild(hint);
  }

  let hintTimer = null;
  const showHint = (msg) => {
    if (!hint) return;
    hint.textContent = msg || "Pehle size select karo, tab unlock hoga 🙂";
    hint.classList.add("is-show");
    clearTimeout(hintTimer);
    hintTimer = setTimeout(() => hint.classList.remove("is-show"), 1800);
  };

  // Detect unlock and trigger shine once
  let wasUnlocked = buyBtn.classList.contains("is-unlocked");

  const triggerUnlockShine = () => {
    buyBtn.classList.add("duofits-just-unlocked");
    setTimeout(() => buyBtn.classList.remove("duofits-just-unlocked"), 1200);
  };

  const observer = new MutationObserver(() => {
    const unlockedNow = buyBtn.classList.contains("is-unlocked");
    if (!wasUnlocked && unlockedNow) {
      triggerUnlockShine();
    }
    wasUnlocked = unlockedNow;
  });

  observer.observe(buyBtn, { attributes: true, attributeFilter: ["class"] });

  // Locked click message
  buyBtn.addEventListener("click", (e) => {
    const unlocked = buyBtn.classList.contains("is-unlocked");
    if (!unlocked) {
      e.preventDefault();
      e.stopPropagation();
      showHint("Pehle size select karo, tab unlock hoga 🙂");
    }
  });
});
